import { ISharingEnterTraffic, TSharingCurrentTraffic } from 'shared/atoms';
import { EPageType } from 'shared/constant';

export const SharingEnterTrafficUtil = {
  getShareContentExtra: (traffic: ISharingEnterTraffic) => {
    return {
      share_content_type: traffic.pageType,
      share_content_id: traffic.pageId || null,
    };
  },
};

export const SharingCurrentTrafficUtil = {
  getEnterPageExtra: (traffic: TSharingCurrentTraffic): Record<string, string> => {
    switch (traffic.pageType) {
      case EPageType.Gallery:
        return {
          enter_page_type: EPageType.Gallery,
          enter_page_id: traffic.groupId,
        };
      case EPageType.FIZZ:
        return {
          enter_page_type: EPageType.FIZZ,
          enter_page_id: traffic.groupId,
        };
      case EPageType.VIDEO:
        return {
          enter_page_type: EPageType.VIDEO,
          enter_page_id: traffic.groupId,
        };
      case EPageType.HASHTAG:
        return {
          enter_page_type: EPageType.HASHTAG,
          enter_page_id: traffic.hashtagId,
        };
      case EPageType.POI:
        return {
          enter_page_type: EPageType.POI,
          enter_page_id: traffic.poiId,
        };
      case EPageType.USER:
      default:
        return {
          enter_page_type: EPageType.USER,
          enter_page_id: traffic.userId,
        };
    }
  },
};
